import React from 'react';
import { connect } from 'dva';
import { framework_tool,utils_tool,component_tool } from '@/tool'
import { templateConfig, reduxTemplateCofig } from './config'
import { WizPhoneCall, WizCallLog } from '@/containers/common';
import { seatsOut } from '@/utils'
const { WizContainer, WizReduxTemplate,modelUtils } = framework_tool;
let {  WizBrowserExport, WizModal } = component_tool;
let { Session } = utils_tool;
const _getValue = (type, key)=> {
  const values = {
    jobState: {
      0: '离职',
      1: '在职',
    },
    dealerState: {
      0: '已关店',
      1: '已开店',
      2: '建设中',
    },
    userType: {
      0: '学员',
      1: 'SGM总部',
      2: 'SGM区域',
      3: '供应商',
    },
    state: {
      1: '激活',
      0: '禁用',
    },
    channel: {
      0: '系统',
      1: '企业号',
      2: 'DP',
      3: '新能源',
    },
  }
  return values[type][key]
}

class PersonManage extends WizContainer {

  componentName = 'PersonManage';

  constructor(props) {
    super(props);
    this.state = {
      callModalShow: false,
      locCallRecord: {},
      callLogShow: false,
    }
    const { history } = props;
    let searchProps = {};
    if (history.location && history.location.pathname === '/org/dealer/lookPositionNumber') {
      if (history.location && history.location.record) {
        searchProps = history.location.record;
        Session.set('searchProps', searchProps)
      } else {
        searchProps = Session.get('searchProps') || {};
      }
    }
    this.searchProps = searchProps;
  }

  propsAndStateOnChange = {
    getFileInfoByFileId: this._downloadFile.bind(this),
    seatsLoginOut: this._seatsLoginOutOver.bind(this),

  }
  componentDidMount() {
    seatsOut({ fun: this._seatsLoginOut })
  }

  _seatsLoginOutOver(nextProps, nextState) {
    if (nextProps.seatsLoginOut.success && nextProps.seatsLoginOut.data) {
    } else {
      wizNotice.error(nextProps.seatsLoginOut.msg);
    }
    return true;
  }
  _seatsLoginOut = (params) => {
    ClinkAgent.setup({ sipPhone: false, debug: false }, function () {
      // 注册退出响应回调方法
      ClinkAgent.registerCallback(ClinkAgent.ResponseType.LOGOUT, function (result) {
        if (result.code === 0) {
          // 退出成功
          console.log('退出成功777')
        } else {
          // 退出失败
        }
      });
    });
    ClinkAgent.logout({ logoutMode: 1, removeBinding: 0 });
    this.doAction({
      path: 'smartPhone/seatsLoginOut',
      payload: {
        key: "seatsLoginOut",
        apiParams: {
          ...params
        }
      }
    });
  }
  _handleIdentityFile(nextProps, nextState, key) {
    let response = nextProps[key]
    const blob =response['result'];
    let link = document.createElement('a');
    let body = document.querySelector('body');

    link.href = window.URL.createObjectURL(blob);
    link.download = "人员任职信息.xls";

    // fix Firefox
    link.style.display = 'none';
    body.appendChild(link);

    link.click();
    body.removeChild(link);

    window.URL.revokeObjectURL(link.href);
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '姓名',
        field: 'fullName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '账号',
        field: 'userName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '手机号',
        field: 'mobile',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '身份证号/工号',
        field: 'idCard',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '邮箱',
        field: 'email',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '用户属性',
        field: 'userType',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: "dp账号状态",
        field: "dpAvtiveStatusCn",
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: "dp人脸识别结果",
        field: "dpAuthenRecordCn",
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '账号状态',
        field: 'state',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '数据来源',
        field: 'channel',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '入职时间',
        field: 'hireTime',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '最新修改时间',
        field: 'updateTime',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '域账号',
        field: 'domainAccount',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
    ]
    if (o['success']) {
      let data = Object.assign([],o['data'])
      data.forEach((val, index) => {
        val['userType'] = _getValue('userType',val['userType'])
        val['state'] = _getValue('state',val['state'])
        val['channel']  = _getValue('channel',val['channel'])
      })
      WizBrowserExport({
        title: '人员信息',
        sheetName: '人员信息',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '人员信息.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleRandomPersonInfo(nextProps, nextState, key) {

    let response = nextProps[key]
    const blob =response['result'];
    let link = document.createElement('a');
    let body = document.querySelector('body');

    link.href = window.URL.createObjectURL(blob);
    link.download = "人员信息.xls";

    // fix Firefox
    link.style.display = 'none';
    body.appendChild(link);

    link.click();
    body.removeChild(link);

    window.URL.revokeObjectURL(link.href);
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _batchChangeState(nextProps, nextState, key) {
    let o = nextProps[key] || {}
    let {code, success, msg, data} = o
    if (success) {
      wizNotice.success({
        duration: 4.5,
        message: <div dangerouslySetInnerHTML={{__html: data && JSON.stringify(data) !== '{}' ? data : msg}}/>
      })
      return true;
    } else {
      wizNotice.error(msg)
      return false;
    }
  }

  _exportStudentCertList(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      let fileId = nextProps.exportStudentCertList.data;
      console.log('fileId===',fileId);
      this.doAction({
        path: 'ossUpload/getFileInfoByFileId',
        payload: {
          key: 'getFileInfoByFileId',
          apiParams: {
            fileId
          }
        }
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }


  /**
   * 下载
   * @param {*} nextProps
   * @param {*} nextState
   * @param {*} key
   */
  _downloadFile(nextProps, nextState, key) {
    console.log('nextProps===',nextProps)
    let {success, data, msg} = nextProps.getFileInfoByFileId
    if (success && data) {
      let {fileId, fileOriginalName, fileUploadStatus} = data;
      let url = getOssFilePath(fileId);
      if (url && fileUploadStatus) {
        const win = window.open(url);
        win.focus();
        return true
      } else {
        Wizmessage.warning('文件还未上传成功，请稍后')
      }
    } else {
      wizNotice.error(msg || '获取文件信息失败,请稍后再试')
      return false;
    }
    return true;
  }

  /**
   * 当作为二级页面展示时，接收参数及修改一些配置
   */
  _getPushProps = () => {
    let { location } = this.props;
    let searchProps = location['record'] && location['record'] && location['record']['searchProps'] ? location['record']['searchProps'] : undefined
    if (!searchProps) {
      searchProps = this.searchProps['searchProps'];
    }
    let btnAccessCheck = searchProps ? false : true
    let templateConfigProps = { searchProps, btnAccessCheck }
    let apiProps = {}
    if ((searchProps && searchProps['org'] && searchProps['org'].length)) {
      let org = searchProps['org'][0]
      apiProps = {
        organizationIdList: [org['orgId']],
        keepInitApiParams: true
      }
    }
    return { templateConfigProps, apiProps }
  }

  /**
    * 拨打电话
  */
  openCall = (record) => {
    this.setState({ callModalShow: true, locCallRecord: record })
  }

  //通话记录
  openCallLog = (record) => {
    this.setState({ callLogShow: true, locCallRecord: record ? record : {} })
  }

  _render() {
    let { callModalShow, locCallRecord, callLogShow } = this.state;
    let pushProps = this._getPushProps()
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig: templateConfig({ ...pushProps['templateConfigProps'],_this:this}),
      apiDataFormat: {
        enable: this._handleCMD,
        reset: this._handleCMD,
        personInfoExport: this._handleFile,
        personIdentityInfoExport: this._handleIdentityFile,
        personInfoExportRandomNumber: this._handleRandomPersonInfo,
        batchChangeState: this._batchChangeState,
        exportStudentCertList: this._exportStudentCertList.bind(this),
      },
      ...pushProps['apiProps']
    })
    return (
      <>
        <WizReduxTemplate {..._reduxTemplateCofig} />
        {callModalShow ? <WizPhoneCall entityType={1} modalShow={callModalShow} record={locCallRecord}
          closeModal={() => this.setState({ callModalShow: false })} /> : null}
        <WizModal title='通话记录' destroyOnClose={true} visible={callLogShow} footer={null} onCancel={() => this.setState({ callLogShow: false })} width={850}>
          <WizCallLog entityType={1} entityId={locCallRecord.id} />
        </WizModal>
      </>)
  }
}

const mapStateToProps = (state, ownProps) => {
  const {ossUpload,smartPhone} = state;
  const getFileInfoByFileId = modelUtils.getModelEntity(ossUpload, 'getFileInfoByFileId');
  const seatsLoginOut = modelUtils.getModelEntity(smartPhone, 'seatsLoginOut');
  return {
    getFileInfoByFileId,
    seatsLoginOut
  }
};

export default connect(mapStateToProps)(PersonManage);
